import React from 'react';
import Issues from './Issues';

const Trending = () => {
  return (
    <div>
      <Issues />
    </div>
  );
};

export default Trending;
